import * as React from 'react';
import { useDropzone, FileWithPath } from 'react-dropzone';
import { AnimatePresence, motion } from "framer-motion"

import './CreateNewCollection.scss'
import { formatBytes } from '../../Hooks/bytesToMB';
import { Previews } from './Previews';
import useClickOutside from '../../Hooks/useClickOutside';
import { useState } from 'react';

export interface IAppProps {
}

export function CreateNewCollection(props: IAppProps) {
    const [hanldeMrktOptionsShow, setHandleMrktOptionsShow] = React.useState(false);
    const [showAdvenceSettings, setShowAdvenceSettings] = React.useState(false);

    const hanldeMinMaxValue = (e: any) => {
        if (e.target.value > 50) {
            e.target.value = 50;
        }
        else if (e.target.value < 0) {
            e.target.value = 0;
        }
    }


    // 1st Drag and drop functionality------------------
    const { acceptedFiles, fileRejections, getRootProps, getInputProps } = useDropzone({
        accept: 'image/gif,image/png,image/webp,video/mp4,video/mp3',
        maxSize: 100000000,
    });
    const files = acceptedFiles.map((file: FileWithPath) => (
        <span
            className="text-cusBlueWhite"
            key={file.path}>
            {file.path} - {formatBytes(file.size)}
        </span>
    ));
    const files2 = acceptedFiles.map((file: FileWithPath) => (
        <span
            className="text-cusBlueWhite"
            key={file.path}>
            {file.path} - {formatBytes(file.size)}
        </span>
    ));



    const handleConnectionsFormSubmit = (e: any) => {
        e.preventDefault()
    }

    const [ehtModalOpen, setEhtModalOpen] = React.useState(false);
    const [ehtText, setEhtText] = useState('EHT')
    const ethModalRef = React.useRef<HTMLHeadingElement>(null);
    useClickOutside(ethModalRef, () => setEhtModalOpen(false))





    return (
        <div className="text-left mx-auto create_new_connection_main_box my-32
        px-[20px] sm:px-0
        sm:max-w-[480px]
        md:max-w-[540px]
        lg:max-w-[740px]
        xl:max-w-[908px]
        2xl:max-w-[1024px]">




            <h1 className="xs:text-2xl xl:text-3xl font-bold text-cusBlack dark:text-white">Create New Collection</h1>

            <form action="" onSubmit={handleConnectionsFormSubmit}>
                <div className="lg:flex-row xs:flex-col flex justify-between items-start mt-5">


                    <div className="flex-1 xs:order-2 lg:order-1 w-full">

                        <div className="mt-4">
                            <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-lg">Choose Type</h4>
                            <p className="xs:text-xxs sm:text-sm text-l-LightBlack dark:text-cusBlueWhite mt-2 w-9/12">Choose “Single” for one of a kind or “Multiple” if you want to sell one collectible multiple times</p>


                            <input type="radio" name="sellType" id="single_sell" className="hidden" />
                            <div className="sell_type_option mt-4">
                                <label htmlFor="single_sell" className="flex cursor-pointer justify-start items-center lightBlueBg xs:p-1.5 sm:p-4 rounded-lg">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={53} height={73} viewBox="0 0 53 73">
                                        <defs>
                                            <linearGradient id="linear-gradient" x1="0.94" y1="0.063" x2="0.065" y2="0.922" gradientUnits="objectBoundingBox">
                                                <stop offset={0} stopColor="#e315e8" />
                                                <stop offset={1} stopColor="#ffd817" />
                                            </linearGradient>
                                        </defs>
                                        <rect id="Rectangle_1368" data-name="Rectangle 1368" width={50} height={70} rx={7} transform="translate(1.5 1.5)" fill="none" stroke="#201e58" strokeLinecap="round" strokeWidth={3} />
                                        <rect id="Rectangle_1369" data-name="Rectangle 1369" width={36} height={21} rx={2} transform="translate(8.5 11.5)" fill="url(#linear-gradient)" />
                                        <line id="Line_62" data-name="Line 62" x2={24} transform="translate(9.75 39.136)" fill="none" stroke="#3f3d77" strokeLinecap="round" strokeWidth={3} />
                                        <line id="Line_64" data-name="Line 64" x2={12} transform="translate(9.75 45.136)" fill="none" stroke="#3f3d77" strokeLinecap="round" strokeWidth={3} />
                                    </svg>

                                    <div className=" xs:ml-3 sm:ml-4">
                                        <h4 className="xs:text-sm sm:text-base dark:font-medium font-bold text-cusBlack dark:text-white">Single</h4>
                                        <p className="text-l-LightBlack dark:text-cusBlueWhite xs:text-xxs sm:text-xs mt-1 sm:w-10/12">If you want to highlight the uniqueness and individuality of your item</p>
                                    </div>
                                </label>
                            </div>

                            <input type="radio" name="sellType" id="multiple_sell" className="hidden" />
                            <div className="sell_type_option mt-5">
                                <label htmlFor="multiple_sell" className="flex cursor-pointer justify-start items-center lightBlueBg xs:p-1.5 sm:p-4 rounded-lg">
                                    <svg width={53} height={73} viewBox="0 0 53 73" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M44.5 1.90698H8.5C4.63401 1.90698 1.5 5.04099 1.5 8.90698V51.907C1.5 55.773 4.63401 58.907 8.5 58.907H44.5C48.366 58.907 51.5 55.773 51.5 51.907V8.90698C51.5 5.04099 48.366 1.90698 44.5 1.90698Z" stroke="#201E58" strokeWidth={3} strokeLinecap="round" />
                                        <path d="M42.5 11.907H10.5C9.39543 11.907 8.5 12.8024 8.5 13.907V30.907C8.5 32.0116 9.39543 32.907 10.5 32.907H42.5C43.6046 32.907 44.5 32.0116 44.5 30.907V13.907C44.5 12.8024 43.6046 11.907 42.5 11.907Z" fill="url(#paint0_linear_0_1)" />
                                        <path d="M9.75 39.407H33.75" stroke="#3F3D77" strokeWidth={3} strokeLinecap="round" />
                                        <path d="M10 64.941H43.5" stroke="#201E58" strokeWidth={3} strokeLinecap="round" />
                                        <path d="M9.75 45.407H21.75" stroke="#3F3D77" strokeWidth={3} strokeLinecap="round" />
                                        <path d="M17 70.941H36.25" stroke="#201E58" strokeWidth={3} strokeLinecap="round" />
                                        <defs>
                                            <linearGradient id="paint0_linear_0_1" x1="10.66" y1="31.605" x2="26.7921" y2="4.42402" gradientUnits="userSpaceOnUse">
                                                <stop stopColor="#E315E8" />
                                                <stop offset={1} stopColor="#00DBFF" />
                                            </linearGradient>
                                        </defs>
                                    </svg>

                                    <div className=" ml-4">
                                        <h4 className="xs:text-sm sm:text-base dark:font-medium font-bold text-cusBlack dark:text-white">Multiple</h4>
                                        <p className="text-l-LightBlack dark:text-cusBlueWhite xs:text-xxs sm:text-xs mt-1 w-10/12">If you want to share your item with a large number of community members</p>
                                    </div>
                                </label>
                            </div>
                        </div>


                        <div className="mt-8">
                            <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-lg">Upload file</h4>

                            <div {...getRootProps({ className: 'dropzone' })}>
                                <input {...getInputProps()} />
                                <div className="bg-[#ffffff] dark:bg-[#0E0631] border-2 border-dashed border-[#D8D8D8] dark:border-[#3d3892] py-10 p-3 mt-3 rounded-xl text-center">
                                    {files.length !== 0
                                        ? <p className="text-white xs:text-xxs sm:text-base">Your File: {files}</p>
                                        : fileRejections.length !== 0
                                            ? <p className="text-red-500 dark:text-red-400 xs:text-xxs sm:text-base">{fileRejections[0]?.errors[0]?.message}</p>
                                            : <p className="text-l-LightBlack dark:text-cusBlueWhite xs:text-xxs sm:text-base">PNG, GIF, WEBP, MP4 or MP3. Max 100mb.</p>
                                    }
                                    <button
                                        className="font-semibold dark:font-medium bg-cusBrightLink dark:bg-black mt-6 text-cusLightLink dark:text-cusLink xs:px-4 sm:px-6 xs:py-1 sm:py-3 rounded-full xs:text-xs sm:text-base">
                                        Choose file
                                    </button>
                                </div>
                            </div>
                        </div>


                        <div className="">
                            {/* <div className="flex justify-between items-center">
                                <div>
                                    <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-lg">Put on marketplace</h4>
                                    <p className="xs:text-xxs sm:text-sm text-cusBlack dark:text-cusBlueWhite">Enter price to allow users instantly purchase your NFT</p>
                                </div>

                                <div className="flex items-center justify-center">
                                    <label htmlFor="toggleB" className="flex items-center cursor-pointer">
                                        <div className="relative">
                                            <input type="checkbox" id="toggleB" name="toggleBtn" className="sr-only" onClick={() => setHandleMrktOptionsShow(!hanldeMrktOptionsShow)} />
                                            <div className="block w-16 h-8 rounded-full toogle_btn_bg" />
                                            <div className="dot absolute left-1.5 top-1 bg-gray-500 w-6 h-6 rounded-full transition" />
                                        </div>
                                    </label>
                                </div>
                            </div> */}



                            <div className="overflow-hidden">

                                <div className={`${hanldeMrktOptionsShow ? 'active' : ' '} grid grid-cols-3 xs:gap-x-3 gap-x-6 mt-5 marketplace_Option_box`}>
                                    <input type="radio" name="marketPlaceOptions" id="fixedPrice" className="hidden" />
                                    <div className="marketplace_Option">
                                        <label htmlFor="fixedPrice" className="flex cursor-pointer h-full w-full flex-col justify-center items-center lightBlueBg xs:p-2 sm:p-4 xs:rounded-md sm:rounded-xl">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="xs:w-6 sm:w-auto" width="36.127" height="32.281" viewBox="0 0 36.127 32.281">
                                                <g id="tag" transform="translate(0 -23.224)">
                                                    <g id="Group_1503" data-name="Group 1503" transform="translate(0 23.224)">
                                                        <g id="Group_1502" data-name="Group 1502">
                                                            <path id="Path_1022" data-name="Path 1022" d="M28.179,23.224H17.087A2.65,2.65,0,0,0,15.214,24L.776,38.436a2.65,2.65,0,0,0,0,3.747L11.868,53.275a2.649,2.649,0,0,0,3.746,0L30.052,38.84a2.656,2.656,0,0,0,.776-1.876V25.873A2.648,2.648,0,0,0,28.179,23.224ZM23.543,32.5a1.987,1.987,0,1,1,1.987-1.987A1.988,1.988,0,0,1,23.543,32.5Z" transform="translate(0 -23.224)" fill="#656391" />
                                                        </g>
                                                    </g>
                                                    <g id="Group_1505" data-name="Group 1505" transform="translate(18.129 25.873)">
                                                        <g id="Group_1504" data-name="Group 1504" transform="translate(0 0)">
                                                            <path id="Path_1023" data-name="Path 1023" d="M234.336,55.224V67.555a2.3,2.3,0,0,1-.676,1.629L218.988,83.855l.225.225a2.649,2.649,0,0,0,3.746,0l13.249-13.246a2.646,2.646,0,0,0,.778-1.873V57.873A2.648,2.648,0,0,0,234.336,55.224Z" transform="translate(-218.988 -55.224)" fill="#656391" />
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                            <p className="xs:text-xxs sm:text-sm mt-2 text-cusBlack dark:text-cusBlueWhite">Fixed price</p>
                                        </label>
                                    </div>

                                    <input type="radio" name="marketPlaceOptions" id="openForBids" className="hidden" />
                                    <div className="marketplace_Option">
                                        <label htmlFor="openForBids" className="flex cursor-pointer h-full w-full flex-col justify-center items-center lightBlueBg xs:p-2 sm:p-4 xs:rounded-md sm:rounded-xl">
                                            <svg id="Group_1506" data-name="Group 1506" className="xs:w-8 sm:w-auto" xmlns="http://www.w3.org/2000/svg" width="46.212" height="22.674" viewBox="0 0 46.212 22.674">
                                                <path id="Path_1024" data-name="Path 1024" d="M34.876,130.4a11.327,11.327,0,0,0-8.017,3.322l-3.753,3.753-3.754-3.754a11.336,11.336,0,1,0,0,16.031l3.753-3.753,3.754,3.753A11.336,11.336,0,1,0,34.876,130.4ZM15.091,145.485a5.284,5.284,0,0,1-1.191.9,5.209,5.209,0,0,1-2.563.661,5.309,5.309,0,1,1,0-10.618,5.231,5.231,0,0,1,2.568.663,5.311,5.311,0,0,1,1.187.893l3.752,3.753Zm19.784,1.557a5.225,5.225,0,0,1-2.57-.664,5.279,5.279,0,0,1-1.184-.893l-3.753-3.753,3.753-3.752a5.309,5.309,0,1,1,3.753,9.062Z" transform="translate(0 -130.396)" fill="#656391" />
                                            </svg>
                                            <p className="xs:text-xxs sm:text-sm mt-2 text-cusBlack dark:text-cusBlueWhite">Open for bids</p>
                                        </label>
                                    </div>

                                    <input type="radio" name="marketPlaceOptions" id="timedAuction" className="hidden" />
                                    <div className="marketplace_Option">
                                        <label htmlFor="timedAuction" className="flex cursor-pointer h-full w-full flex-col justify-center items-center lightBlueBg xs:p-2 sm:p-4 xs:rounded-md sm:rounded-xl">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="xs:w-6 sm:w-auto" width="32.281" height="32.281" viewBox="0 0 32.281 32.281">
                                                <g id="stopwatch" transform="translate(-550.86 -285.526)">
                                                    <path id="Exclusion_1" data-name="Exclusion 1" d="M16.141,32.281a16.261,16.261,0,0,1-3.253-.328,16.053,16.053,0,0,1-5.772-2.429,16.188,16.188,0,0,1-5.848-7.1,16.055,16.055,0,0,1-.94-3.03,16.3,16.3,0,0,1,0-6.506A16.052,16.052,0,0,1,2.757,7.116a16.187,16.187,0,0,1,7.1-5.848,16.059,16.059,0,0,1,3.03-.941,16.218,16.218,0,0,1,6.5,0,16.073,16.073,0,0,1,5.769,2.431,16.205,16.205,0,0,1,5.848,7.1,16.076,16.076,0,0,1,.942,3.028,16.218,16.218,0,0,1,0,6.5,16.052,16.052,0,0,1-2.429,5.772,16.187,16.187,0,0,1-7.1,5.848,16.06,16.06,0,0,1-3.03.94A16.26,16.26,0,0,1,16.141,32.281Zm0-29.053A12.913,12.913,0,1,0,29.053,16.141,12.927,12.927,0,0,0,16.141,3.228Z" transform="translate(550.86 285.526)" fill="#656391" />
                                                    <path id="Path_1026" data-name="Path 1026" d="M117.966,160.632v-11.3a11.3,11.3,0,1,0,11.3,11.3Z" transform="translate(449.035 141.035)" fill="#656391" />
                                                </g>
                                            </svg>
                                            <p className="xs:text-xxs sm:text-sm mt-2 text-cusBlack dark:text-cusBlueWhite">Timed auction</p>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>




                        <div className="mt-8">
                            <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-lg">Price</h4>

                            <div className="relative mt-3">
                                <input type="text" name="" id="" placeholder="Enter price for one piece"
                                    className="xs:text-xs sm:text-base bg-transparent w-full h-full outline-none text-cusBlack dark:text-white pr-14
                                    lightBlueBg p-6 rounded-xl duration-300 form-input transition-all" />

                                <div className="absolute top-4 right-5" onClick={() => setEhtModalOpen(!ehtModalOpen)}>
                                    <button className="bg-[#EFEFEF] dark:bg-[#363375] py-1 px-2 rounded flex justify-center items-center">
                                        <p className="text-l-LightBlack dark:text-[#6F6DAB] text-xl font-black mr-2">{ehtText}</p>
                                        <svg xmlns="http://www.w3.org/2000/svg" className={`${ehtModalOpen ? 'rotate-180' : ''} w-3 lg:w-4 stroke-l-LightBlack dark:stroke-[#6f6dab] transition-all`} viewBox="0 0 18.657 11.328">
                                            <path id="Path_1027" data-name="Path 1027" d="M3208,826l6.5,6.5,6.5-6.5" transform="translate(-3205.171 -823.172)" fill="none" stroke="" strokeLinecap="round" strokeLinejoin="round" strokeWidth={4} />
                                        </svg>
                                    </button>
                                </div>

                                <AnimatePresence>
                                    {ehtModalOpen &&
                                        <motion.div
                                            initial={{ height: 0, width: 0 }}
                                            animate={{ height: '', width: '' }}
                                            exit={{ height: 0, width: 0 }}
                                            ref={ethModalRef}
                                            className="absolute z-40 right-5 top-14 w-44 bg-white shadow-2xl dark:bg-[#363375] rounded overflow-hidden">
                                            {["EHT 1", "EHT 2", "EHT 3", "EHT 4",].map(item =>
                                                <button className="w-full py-2 hover:bg-gray-200 hover:dark:bg-[#3c379d] px-3 flex justify-start items-center" key={item}
                                                    onClick={() => { setEhtModalOpen(false); setEhtText(item) }}>
                                                    <p className="text-l-LightBlack dark:text-white text-lg font-black ml-2">{item}</p>
                                                </button>
                                            )}
                                        </motion.div>
                                    }
                                </AnimatePresence>
                            </div>

                            <p className="xs:text-xs sm:text-sm mt-2 text-cusBlack dark:text-cusBlueWhite">Service fee <span className="text-black font-extrabold xs:text-xs sm:text-sm dark:font-normal dark:text-white ">2.5%</span> <br />
                                You will receive <span className="text-black xs:text-xs sm:text-sm font-extrabold dark:font-normal dark:text-white ">0 ETH</span></p>
                        </div>


                        <div className="mt-8">
                            <div className="flex justify-between items-center">
                                <div>
                                    <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-lg">Unlock once purchased</h4>
                                    <p className="xs:text-xxs sm:text-sm text-cusBlack dark:text-cusBlueWhite">Detailed meta data will be unlocked after successful transition</p>
                                </div>

                                <div className="flex items-center justify-center">
                                    <label htmlFor="unlockOnePurchasedBtn" className="flex items-center cursor-pointer">
                                        <div className="relative">
                                            <input type="checkbox" id="unlockOnePurchasedBtn" name="unlockOnePurchased" className="sr-only" />
                                            <div className="block w-16 h-8 rounded-full toogle_btn_bg" />
                                            <div className="dot absolute left-1.5 top-1 w-6 h-6 rounded-full transition" />
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>


                        {/* <div className="mt-8">
                            <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-lg">Choose collection</h4>

                            <div className="choose_collection_box mt-3 grid xs:grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4">
                                <input type="radio" name="chooseCollection" id="create" className="hidden" />
                                <div className="choose_collection_option">
                                    <label htmlFor="create" className="lightBlueBg xs:p-2 sm:p-4 rounded-lg cursor-pointer flex justify-start items-center">
                                        <div className="xs:w-10 sm:w-14 xs:h-10 sm:h-14 rounded-full bg-slate-500 dark:bg-cusGray flex justify-center items-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="#FFFFFF" strokeWidth={2}>
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
                                            </svg>
                                        </div>
                                        <div className="ml-4">
                                            <h4 className="text-sm font-extrabold dark:font-medium text-cusBlack dark:text-white">Create</h4>
                                            <p className="text-xs text-cusBlack dark:text-cusBlueWhite mt-2">SRI - 7746</p>
                                        </div>
                                    </label>
                                </div>

                                <input type="radio" name="chooseCollection" id="unc" className="hidden" />
                                <div className="choose_collection_option">
                                    <label htmlFor="unc" className="lightBlueBg xs:p-2 sm:p-4 rounded-lg cursor-pointer flex justify-start items-center">
                                        <div className="xs:w-10 sm:w-14 xs:h-10 sm:h-14 rounded-full flex justify-center items-center unc_logo">
                                            <div className="flex justify-center items-center bg-cusBlack h-full w-full rounded-full">
                                                <img src={unc_logo} alt="" className="w-10/12" />
                                            </div>
                                        </div>
                                        <div className="ml-4">
                                            <h4 className="text-sm font-extrabold dark:font-medium text-cusBlack dark:text-white">Create</h4>
                                            <p className="text-xs text-cusBlack dark:text-cusBlueWhite mt-2">SRI - 7746</p>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div> */}



                        <div className="mt-8">
                            <div className="flex justify-between items-center">
                                <div>
                                    <div className="flex justify-start items-center">
                                        <h4 className="mr-5 text-cusBlack font-bold dark:font-medium dark:text-white text-lg">Free Listing</h4>
                                        <div className="w-6 h-6 flex justify-center items-center rounded-full lightBlueBg">
                                            <p className="text-cusBlack dark:text-cusBlueWhite ">?</p>
                                        </div>
                                    </div>
                                    <p className="xs:text-xs sm:text-sm text-cusBlack dark:text-cusBlueWhite">Buyer will pay gas fees for listing</p>
                                </div>

                                {/* <div className="flex items-center justify-center">
                                    <label htmlFor="freeMintingBtn" className="flex items-center cursor-pointer">
                                        <div className="relative">
                                            <input type="checkbox" id="freeMintingBtn" name="freeMinting" className="sr-only" />
                                            <div className="block w-16 h-8 rounded-full toogle_btn_bg" />
                                            <div className="dot absolute left-1.5 top-1 w-6 h-6 rounded-full transition" />
                                        </div>
                                    </label>
                                </div> */}
                            </div>
                        </div>



                        <div className="mt-8">
                            <h4 className="mr-5 text-cusBlack font-bold dark:font-medium dark:text-white text-lg">Name</h4>
                            <input type="text" name="" id="" placeholder='e. g. "Redeemable T-Shirt with logo"'
                                className="lightBlueBg p-6 rounded-xl duration-300 mt-3
                                    form-input transition-all w-full h-full outline-none text-cusBlack dark:text-white pr-14" />
                        </div>

                        <div className="mt-8">
                            <h4 className="mr-5 text-cusBlack font-bold dark:font-medium dark:text-white text-lg">Description <span className="text-gray-400 dark:text-cusBlueWhite">(Optional)</span></h4>
                            <textarea name="" id=""
                                placeholder='e. g. "After purchasing you’ll be able to get the real T-Shirt"'
                                cols={30} rows={4}
                                className="lightBlueBg p-6 rounded-xl mt-3
                                    form-input w-full h-full outline-none text-cusBlack dark:text-white pr-14"
                            ></textarea>

                            <p className="text-sm text-l-LightBlack dark:text-cusBlueWhite mt-2">With preserved line-breaks</p>
                        </div>

                        <div className="mt-8">
                            <h4 className="mr-5 text-cusBlack font-bold dark:font-medium dark:text-white text-lg">Royalties</h4>
                            <div className="relative">
                                <input type="number" name="" id="" defaultValue="30" min="0" max="50" onKeyUp={hanldeMinMaxValue}
                                    className="lightBlueBg p-6 rounded-xl duration-300 mt-3
                                    form-input transition-all w-full h-full outline-none text-cusBlack dark:text-white pr-14" />
                                <h4 className="text-l-LightBlack dark:text-cusBlueWhite text-2xl absolute top-8 right-5">%</h4>
                            </div>
                            <p className="text-sm text-l-LightBlack dark:text-cusBlueWhite mt-2">Suggested: 0%, 10%, 20%, 30%. Maximum is 50%</p>
                        </div>



                        <div className="mt-8">
                            <div className="flex justify-between items-center">
                                <div>
                                    <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-lg">Post on Activity</h4>
                                    <p className="text-sm text-cusBlack dark:text-cusBlueWhite">Add this NFTs to your post activity</p>
                                </div>

                                <div className="flex items-center justify-center">
                                    <label htmlFor="postOnActivityBtn" className="flex items-center cursor-pointer">
                                        <div className="relative">
                                            <input type="checkbox" id="postOnActivityBtn" name="postOnActivity" className="sr-only" />
                                            <div className="block w-16 h-8 rounded-full toogle_btn_bg" />
                                            <div className="dot absolute left-1.5 top-1 w-6 h-6 rounded-full transition" />
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>


                        <div className="">
                            <input type="text" name="" id="" placeholder='Add your post comments'
                                className="lightBlueBg p-5 rounded-xl mt-6 relative transition-all form-input
                                 w-full h-full outline-none text-cusBlack dark:text-white pr-14" />
                        </div>

                        <div className="mt-8">
                            <div {...getRootProps({ className: 'dropzone2' })}>
                                <input {...getInputProps()} />
                                <div className="bg-[#ffffff] dark:bg-[#0E0631] border-2 border-dashed border-[#D8D8D8] dark:border-[#3d3892] py-10 p-3 mt-3 rounded-xl text-center">
                                    {files2.length !== 0
                                        ? <p className="text-white xs:text-xxs sm:text-base">Your File: {files2}</p>
                                        : fileRejections.length !== 0
                                            ? <p className="text-red-500 dark:text-red-400 xs:text-xxs sm:text-base">{fileRejections[0]?.errors[0]?.message}</p>
                                            : <p className="text-l-LightBlack dark:text-cusBlueWhite xs:text-xxs sm:text-base">PNG, GIF, WEBP, MP4 or MP3. Max 100mb.</p>
                                    }
                                    <button
                                        className="font-semibold dark:font-medium bg-cusBrightLink dark:bg-black mt-6 text-cusLightLink dark:text-cusLink xs:px-4 sm:px-6 xs:py-1 sm:py-3 rounded-full xs:text-xs sm:text-base">
                                        Choose file
                                    </button>
                                </div>
                            </div>
                        </div>


                        <button
                            onClick={() => setShowAdvenceSettings(!showAdvenceSettings)}
                            className="xs:text-sm md:text-lg font-semibold text-cusBlack dark:text-white mt-8 xs:p-4 sm:p-6 xl:p-7 2xl:p-8 w-full rounded-xl 
                            dark:bg-[#292757] dark:hover:bg-[#3c3975] bg-[#00000020] hover:bg-[#00000040] transition-all">
                            {!showAdvenceSettings ? "Show advanced settings" : "Hide advanced settings"}
                        </button>


                        {showAdvenceSettings &&
                            <div className="mb-8">
                                <div className="mt-8">
                                    <h4 className="mr-5 text-cusBlack font-bold dark:font-medium dark:text-white text-lg">Properties <span className="text-gray-400 dark:text-cusBlueWhite">(Optional)</span></h4>
                                    <div className="grid xs:grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 items-center">
                                        <input type="text" name="" id="" placeholder='e. g. "size"'
                                            className="lightBlueBg p-6 rounded-xl duration-300 mt-3
                                                form-input transition-all w-full outline-none text-cusBlack dark:text-white pr-14" />
                                        <input type="text" name="" id="" placeholder='e. g. "M"'
                                            className="lightBlueBg p-6 rounded-xl duration-300 mt-3
                                                form-input transition-all w-full outline-none text-cusBlack dark:text-white pr-14" />
                                    </div>
                                </div>

                                <div className="mt-8">
                                    <h4 className="mr-5 text-cusBlack font-bold dark:font-medium dark:text-white text-lg">Alternative text for NFT <span className="text-gray-400 dark:text-cusBlueWhite">(Optional)</span></h4>
                                    <input type="text" name="" id="" placeholder='Image description in details (do not start with word “image”)'
                                        className="lightBlueBg p-6 rounded-xl duration-300 mt-3
                                            form-input transition-all w-full outline-none text-cusBlack dark:text-white pr-14" />
                                    <p className="text-sm text-l-LightBlack dark:text-cusBlueWhite mt-2">Text that will be used in VoiceOver for people with disabilities</p>
                                </div>
                            </div>
                        }

                        <button className="xs:text-sm md:text-lg font-semibold text-white mt-5 xs:p-4 sm:p-6 xl:p-7 2xl:p-8 w-full rounded-xl  gradientBtn">
                            Create Item
                        </button>
                    </div>




                    <Previews />





                </div>
            </form >
        </div >
    );
}
